export default __webpack_public_path__ + "static/media/img14.37089ffc.png";